import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { NotificationFilterComponent } from './notification-filter/notification-filter.component';
import { NotificationTableComponent } from './notification-table/notification-table.component';
import { NotificationSearchComponent } from './notification-search/notification-search.component';
import { MatCardModule } from '@angular/material/card';
import { OneFilteringChipModule } from '@one/angular-kit/indicator';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { OneFormFieldModule } from '@one/angular-kit/form';
import { OneEditableDropdownModule,OneSelectDropdownModule } from '@one/angular-kit/form';

import { OneIconModule } from '@one/angular-kit/icon';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { OneChipModule } from '@one/angular-kit/indicator';
import { UniqueIdDialogComponent } from './unique-id-dialog/unique-id-dialog.component';
import { OneDialogModule, OneSnackBarModule } from '@one/angular-kit/modal';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';

import { NotificationDetailsComponent } from './notification-details/notification-details.component';
import { OneBreadcrumbModule } from '@one/angular-kit/navigation';
import { MatListModule } from '@angular/material/list';
import { OneListModule } from '@one/angular-kit/layout';
import { NotificationRecipientsTableComponent } from './notification-recipients-table/notification-recipients-table.component';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { OneMenuModule } from '@one/angular-kit/navigation';
import { StatusDialogComponent } from './status-dialog/status-dialog.component';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { AppUtils } from '../../../shared/utilities/app-utils';
import { FeedbackDetailsComponent } from './feedback-details/feedback-details.component';
import { NotificationAddRecipientsTemplateComponent } from './notification-add-recipients-template/notification-add-recipients-template.component';
import { NotificationAddRecipientsTemplateDialogComponent } from './notification-add-recipients-template-dialog/notification-add-recipients-template-dialog.component';
import { NotificationAddRecipientService } from './notification-add-recipients-template/notification-add-recipients-template.service';
import { MatStepperModule } from '@angular/material/stepper';
import { OneHorizontalStepperModule } from '@one/angular-kit/pattern';
import { OneVerticalStepperModule } from '@one/angular-kit/pattern';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatPaginatorModule} from '@angular/material/paginator';
import { NotificationAuditTrailComponent } from './notification-audit-trail/notification-audit-trail.component';
import { OneTopbarModule } from '@one/angular-kit/navigation';
import {OneBottomNavigationModule} from '@one/angular-kit/navigation';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {OneCardModule} from '@one/angular-kit/layout';
import { FilterOverlayDialogComponent } from './filter-overlay-dialog/filter-overlay-dialog.component';
import { DisclaimerDailogComponent } from './disclaimer-dailog/disclaimer-dailog.component';
import { ViewReminderDetailsComponent } from './view-reminder-details/view-reminder-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ResendDetailsComponent } from './resend-details/resend-details.component';
import { LsoAcknowledgementComponent } from './lso-acknowledgement/lso-acknowledgement.component';
import { FileUploadFeatureModule } from "../create-notification/fileUpload/file-upload.module";
import { DueDateReminderModule } from "../create-notification/due-date-reminder/due-date-reminder.module";
import { NotificationAccountsTableComponent } from './notification-accounts-table/notification-accounts-table.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { ContactsTableComponent } from './contacts-table/contacts-table.component';
import { AuditTrailSearchComponent } from './audit-trail-search/audit-trail-search.component';
import { FileFormatDialogComponent } from './file-format-dialog/file-format-dialog.component';
import { LSOAcknowledgementNoticeComponent } from './lsoacknowledgement-notice/lsoacknowledgement-notice.component';
import { AddNoteComponent } from './notification-details/add-note/add-note.component';
@NgModule({
    declarations: [
        NotificationComponent,
        NotificationFilterComponent,
        NotificationTableComponent,
        NotificationSearchComponent,
        UniqueIdDialogComponent,
        NotificationDetailsComponent,
        NotificationRecipientsTableComponent,
        StatusDialogComponent,
        ContactDetailsComponent,
        FeedbackDetailsComponent,
        NotificationAddRecipientsTemplateComponent,
        NotificationAddRecipientsTemplateDialogComponent,
        NotificationAuditTrailComponent,
        FilterOverlayDialogComponent,
        DisclaimerDailogComponent,
        ViewReminderDetailsComponent,
        ResendDetailsComponent,
        LsoAcknowledgementComponent,
        NotificationAccountsTableComponent,
        AccountDetailsComponent,
        ContactsTableComponent,
        AuditTrailSearchComponent,
        FileFormatDialogComponent,
        LSOAcknowledgementNoticeComponent,
        AddNoteComponent
    ],
    providers: [AppUtils, NotificationAddRecipientService],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatToolbarModule,
        OneFilteringChipModule,
        MatAutocompleteModule,
        OneFormFieldModule,
        MatPaginatorModule,
        OneBottomNavigationModule,
        OneIconModule,
        OneTopbarModule,
        OneCardModule,
        MatDatepickerModule,
        MatNativeDateModule,
        OneTableModule,
        MatTableModule,
        CdkTableModule,
        MatCheckboxModule,
        MatSortModule,
        MatButtonModule,
        MatSidenavModule,
        MatChipsModule,
        MatSelectModule,
        OneChipModule,
        OneDialogModule,
        OneSnackBarModule,
        MatRadioModule,
        MatDialogModule,
        OneBreadcrumbModule,
        MatTabsModule,
        MatListModule,
        OneListModule,
        DragDropModule,
        RouterModule,
        MatMenuModule,
        OneMenuModule,
        OneEditableDropdownModule, OneSelectDropdownModule,
        MatTableExporterModule,
        MatStepperModule, OneHorizontalStepperModule, OneVerticalStepperModule,
        FileUploadFeatureModule,
        DueDateReminderModule
    ]
})
export class NotificationModule {}
